import React, { useState } from "react";
import { useEffect } from "react";
import "./HomePage.css";
import { useNavigate } from "react-router-dom";
import PaymentPlanWindow from "../components/PaymentPlanWindow";
import { setLoginTime } from "../utils/sessionTime";
import { useWindowSize } from "../hooks/windowSize";

import { trackPageVisit } from "../competency/PageTracker";
import Swal from "sweetalert2";
//import MinimizerDetector from "../components/MinimizerDetector";
import { isTokenExpired } from "../components/TokenHelper";


// after successful login
setLoginTime();

// On the destination homepage




function HomePage() {

  const [userId, setUserId] = useState(null);
  const [userData, setUserData] = useState(null);

  


  useEffect(() => {
    const fetchUserData = async () => {
      // 1. Check localStorage first
      let token = localStorage.getItem('token');
      if (token && isTokenExpired(token)) {
        console.log('❌ Token expired, logging out');
        localStorage.removeItem('token');
        window.location.href = 'https://nktechhub.com/login';
        return;
      }

      if (token) {
        try {
          const userInfo = await fetch(`https://api.nktechhub.com/user/v1/get-data`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          const parsedData = await userInfo.json();
          setUserId(parsedData.user.id);
          setUserData(parsedData.user);
          window.history.replaceState({}, document.title, window.location.pathname);

          return;
        } catch (error) {
          console.error('Error parsing localStorage data:', error);
          localStorage.removeItem('dcs_simulator_user_data');
        }
      }

      // 2. If no localStorage, check session ID in URL
      const params = new URLSearchParams(window.location.search);
      token = params.get('token');
      localStorage.setItem('token', token);

      if (!token) {
        console.log('❌ No token ID found and no localStorage data');
        return;
      }

      if (isTokenExpired(token)) {
        console.log('❌ Token expired, logging out');
        localStorage.removeItem('token');
        window.location.href = 'https://nktechhub.com/login';
        return;
      }

      try {
        // 3. Fetch user data from backend using session ID
        const response = await fetch(`https://api.nktechhub.com/user/v1/get-data`, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Failed to get session data');
        }

        const data = await response.json();

        // 4. Set user data
        setUserId(data.user.id);
        setUserData(data.user);


        // 6. Clean URL (remove session ID)
        window.history.replaceState({}, document.title, window.location.pathname);

      } catch (error) {
        console.error('❌ Error fetching session:', error);
        
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {

    trackPageVisit("HomePage");

  }, []);




  // const checkMobileRedirect = () => {
  //   if (deviceType === "Mobile") {

  //     Swal.fire({
  //       title: "Mobile Access Detected",
  //       text: "For the best experience, please access the DCS Simulator on a desktop or laptop computer.",
  //       icon: "info",
  //       confirmButtonText: "OK"
  //     }).then(() => {
  //       // Optionally, you can redirect to a mobile-friendly page or close the simulator
  //       // window.location.href = "/mobile-info"; // Example redirect
  //       console.log("Mobile access detected, showing alert");
  //       return false;
  //     });
  //   } else if (deviceType === "Tablet") {
  //     Swal.fire({
  //       title: "Tablet Access Detected",
  //       text: "For the best experience, please access the DCS Simulator on a desktop or laptop computer.",
  //       icon: "info",
  //       confirmButtonText: "OK"
  //     }).then(() => {
  //       console.log("Tablet access detected, showing alert");
  //       return false;
  //     });
  //   } else {
  //     return true;
  //   }
  // };


  const navigate = useNavigate();

  // ================= ICON DATA =================
  const [desktopIcons, setDesktopIcons] = useState([
    {
      id: 1,
      name: "Refinery",
      image: "/icons/Refinery.png",
      x: 40,
      y: 90,
      plants: [
        {
          name: "1000 BPD Modular Refinery",
          status: "green",
          equipment: [
            "Unloading System",
            "Tank Farm System",
            "Crude Pumps",
            "Heat Exchanger Units",
            "Furnace",
            "Distillation Column",
            "Stripper",
            "Kettle Reboiler",
            "Control Valves",
            "Reflux Drum",
            "Naptha Vaporization System",
            "Instrument Air System",
            "Nitrogen Generation Unit",
            "Steam Boiler System",
            "Product Loading Unit",
          ],
        },
        {
          name: "30,000 BPD Modular Refinery",
          status: "green",
          equipment: [
            "Crude Heater",
            "Vacuum Column",
            "Hydrotreater",
          ],
        },
        {
          name: "10,000 BPD Hydroskimming Refinery",
          status: "red",
          equipment: [
            "Crude Heater",
            "Atmospheric Column",
            "Reformer Unit",
          ],
        },

        {
          name: "100,000 BPD Conventional Refinery",
          status: "red",
          equipment: [
            "CDU",
            "VDU",
            "FCC Unit",
            "Hydrocracker",
          ],
        },
      ],
    },

    {
      id: 2,
      name: "Gas Plant",
      image: "/icons/Gas Plant.png",
      x: 40,
      y: 220,
      plants: [
        {
          name: "50 MMSCFD Gas Plant",
          status: "red",
          equipment: ["Slug Catcher", "Inlet Separator", "Dehydration Unit"],
        },
        {
          name: "200 MMSCFD Gas Processing Plant",
          status: "red",
          equipment: ["Amine Unit", "TEG Unit", "Compression Train"],
        },
        {
          name: "500 MMSCFD LNG Feed Gas Plant",
          status: "red",
          equipment: ["Acid Gas Removal", "Dehydration", "NGL Recovery"],
        },
      ],
    },

    {
      id: 3,
      name: "Offshore",
      image: "/icons/offshore.png",
      x: 40,
      y: 350,
      plants: [
        {
          name: "250,000 BPD Offshore Production DCS",
          status: "green",
          equipment: [
            "Dry Gas Well and Wellhead Assembly",
            "Crude Dominated Well and Wellhead Assembly",
            "Mix Well and Wellhead Assembly",
            "Wellhead Manifold",
            "Pig Launcher and Pig Reciever",
            "Test Separator",
            "First Stage Separator",
            "Second Stage Separator",
            "Third Stage Separator",
            "Sludge Catcher",
            "Crude Dehydrator",
            "Crude Export System",
            "Gas Compression System",
            "Gas Sweetening System",
            "TEG Contactor and Regeneration System",
            "Gas Export System",
            "Produced Water Treatment",
            "Sea Water Treatment",
            "Water Injection System",
            "Corrosion Inhibition System",
            "Flare System",
          ],
        },
      ],
    },

    {
      id: 4,
      name: "Onshore",
      image: "/icons/onshore.png",
      x: 180,
      y: 90,
      plants: [
        {
          name: "Onshore Production Facility (OPF)",
          status: "red",
          equipment: ["Separator Train", "Heater Treater", "Storage Tank"],
        },
        {
          name: "Gathering Station System",
          status: "red",
          equipment: ["Flowlines", "Manifold", "Test Separator"],
        },
      ],
    },

    {
      id: 5,
      name: "Methanol",
      image: "/icons/methanol.png",
      x: 180,
      y: 220,
      plants: [
        {
          name: "Small Scale Methanol Plant",
          status: "red",
          equipment: ["Reformer", "Shift Reactor", "Methanol Reactor"],
        },
        {
          name: "Industrial Methanol Complex",
          status: "red",
          equipment: ["Syngas Unit", "Compression", "Distillation"],
        },
      ],
    },

    {
      id: 6,
      name: "Ethanol",
      image: "/icons/ethanol.jpg",
      x: 180,
      y: 350,
      plants: [
        {
          name: "Bio-Ethanol Plant",
          status: "red",
          equipment: ["Fermenter", "Distillation", "Dehydration Unit"],
        },
        {
          name: "Industrial Ethanol Production Unit",
          status: "red",
          equipment: ["Mash Tank", "Column", "Storage"],
        },
      ],
    },
  ]);


  const [showPaymentWindow, setShowPaymentWindow] = useState(false);

  // ================= DRAG ICON =================
  const [draggingId, setDraggingId] = useState(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  // ================= WINDOWS =================
  const [selectedIcon, setSelectedIcon] = useState(null);

  const [selectedPlantItem, setSelectedPlantItem] = useState(null);

  const [windowPos, setWindowPos] = useState({ x: 300, y: 120 });
  const [windowDragging, setWindowDragging] = useState(false);
  const [windowOffset, setWindowOffset] = useState({ x: 0, y: 0 });

  const [lockPopup, setLockPopup] = useState(false);

  const [systemPos, setSystemPos] = useState({ x: 420, y: 150 });
  const [systemDragging, setSystemDragging] = useState(false);
  const [systemOffset, setSystemOffset] = useState({ x: 0, y: 0 });

  // ================= ICON CLICK =================
  const handleIconDoubleClick = (icon) => {
    setSelectedIcon(icon);
    setSelectedPlantItem(null);
  };

  // ================= PLANT CLICK =================
  const handlePlantClick = (plant) => {
    if (plant.status === "red") {
      setLockPopup(true);
      setSelectedPlantItem(null);
    } else {
      setSelectedPlantItem(plant);
      setLockPopup(false);
    }
  };

  // ================= ICON DRAG =================
  const startDrag = (e, icon) => {
    setDraggingId(icon.id);
    setOffset({
      x: e.clientX - icon.x,
      y: e.clientY - icon.y,
    });
  };

  const handleMouseMove = (e) => {
    if (draggingId) {
      setDesktopIcons((prev) =>
        prev.map((icon) =>
          icon.id === draggingId
            ? {
              ...icon,
              x: e.clientX - offset.x,
              y: e.clientY - offset.y,
            }
            : icon
        )
      );
    }

    if (windowDragging) {
      setWindowPos({
        x: e.clientX - windowOffset.x,
        y: e.clientY - windowOffset.y,
      });
    }

    if (systemDragging) {
      setSystemPos({
        x: e.clientX - systemOffset.x,
        y: e.clientY - systemOffset.y,
      });
    }
  };

  const stopDrag = () => {
    setDraggingId(null);
    setWindowDragging(false);
    setSystemDragging(false);
  };

  const startWindowDrag = (e) => {
    setWindowDragging(true);
    setWindowOffset({
      x: e.clientX - windowPos.x,
      y: e.clientY - windowPos.y,
    });
  };

  const startSystemDrag = (e) => {
    setSystemDragging(true);
    setSystemOffset({
      x: e.clientX - systemPos.x,
      y: e.clientY - systemPos.y,
    });
  };


  // const loginAlert = () => {
  //   if (deviceType === "Mobile") {
  //     Swal.fire({
  //       title: "Mobile Access Detected",
  //       text: "You cannot login on a mobile device.",
  //       icon: "info",
  //       confirmButtonText: "OK"
  //     });
  //     return;
  //   } else if (deviceType === "Tablet") {
  //     Swal.fire({
  //       title: "Tablet Access Detected",
  //       text: "You cannot login on a tablet device.",
  //       icon: "info",
  //       confirmButtonText: "OK"
  //     });
  //     return;
  //   }

  //   Swal.fire({
  //     title: "Access Restricted",
  //     text: "This simulator is in testing stage. Please enter the access password.",
  //     icon: "info",
  //     input: "password",
  //     inputPlaceholder: "Enter password",
  //     inputAttributes: {
  //       autocapitalize: "off",
  //       autocorrect: "off"
  //     },
  //     showCancelButton: true,
  //     confirmButtonText: "Access Simulator",
  //     cancelButtonText: "Cancel",
  //     preConfirm: (password) => {
  //       if (!password) {
  //         Swal.showValidationMessage("Password is required");
  //         return false;
  //       }
  //       return password;
  //     }
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const enteredPassword = result.value;
  //       const correctPassword = "testdcs123"; // Change this to your desired password

  //       if (enteredPassword === correctPassword) {
  //         Swal.fire({
  //           icon: "success",
  //           title: "Access Granted",
  //           text: "Redirecting to DCS Simulator...",
  //           timer: 1500,
  //           showConfirmButton: false
  //         }).then(() => {
  //           navigate("/WellComp", { state: { fromLogin: true } });
  //         });
  //       } else {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Wrong Password",
  //           text: "Incorrect password. Please contact your instructor for access.",
  //           confirmButtonText: "Try Again"
  //         }).then(() => {
  //           // Optionally, allow retry by calling loginAlert again
  //           loginAlert();
  //         });
  //       }
  //     }
  //   });
  // };


  return (
    <div
      className="desktop-home"
      onMouseMove={handleMouseMove}
      onMouseUp={stopDrag}
      onMouseLeave={stopDrag}
    >
      

      {/* HEADER */}
      <div
        className="desktop-header"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <div>NK Tech Industrial DCS System</div>
        <button
          className="logout-btn"
          onClick={() => {
            localStorage.removeItem('dcs_simulator_user_data');
            window.location.href = 'https://nktechhub.com/login';
          }}
        >n
          {userData ? "Logout" : "Guest"}
        </button>
      </div>

      {/* ICONS */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '2px 0px 4px 50px' }}>
        <img
          src={`https://ui-avatars.com/api/?name=${userData?.firstName || 'User'}+${userData?.lastName || ''}&size=40&background=667eea&color=fff&bold=true`}
          alt="User"
          style={{ width: '2rem', height: '2rem', borderRadius: '50%' }}
        />
        <span style={{ color: 'white', fontWeight: '500' }}>{userData ? userData?.firstName + " " + userData?.lastName : "User"}</span>
      </div>
      {desktopIcons.map((icon) => (
        <div
          key={icon.id}
          className="desktop-icon"
          style={{ left: icon.x, top: icon.y, position: "absolute" }}
          onMouseDown={(e) => startDrag(e, icon)}
          onClick={() => handleIconDoubleClick(icon)}
        >
          <img src={icon.image} className="desktop-icon-img" alt="" />
          <span className="desktop-icon-text">{icon.name}</span>
        </div>
      ))}

      {/* ================= WINDOW 1 - Plant List ================= */}
      {selectedIcon && !selectedPlantItem && (
        <div className="plant-window plant-window-list">
          <div className="plant-window-header" onMouseDown={startWindowDrag}>
            <span>{selectedIcon.name} Plants</span>
            <button onClick={() => setSelectedIcon(null)}>✕</button>
          </div>

          <div className="plant-window-body">
            {selectedIcon.plants.map((p, i) => (
              <div
                key={i}
                className={`plant-item ${p.status}`}
                onClick={() => handlePlantClick(p)}
              >
                {p.status === "red" ? "🔒 " : " "}
                {p.name}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ================= LOCK POPUP ================= */}
      {lockPopup && (
        <div className="plant-window plant-window-lock">
          <div className="plant-window-header">
            <span>Access Denied</span>
            <button onClick={() => setLockPopup(false)}>✕</button>
          </div>
          <div className="plant-window-body">
            <p>DCS System is Still Undergoing Development - Check back Later</p>
          </div>
        </div>
      )}


      {/* ================= WINDOW 3 - Plant Details ================= */}
      {selectedPlantItem && (
        <div className="plant-window plant-window-details">
          <div className="plant-window-header" onMouseDown={startSystemDrag}>
            <span>{selectedPlantItem.name}</span>
            <button onClick={() => setSelectedPlantItem(null)}>✕</button>
          </div>

          <div className="plant-window-body">
            <h4>Purchasing this DCS training package will enable you gain practical experience in operating fully simulated industrial equipment listed below. You will interact with real process units and controls designed to mirror live plant operations used in modern oil and gas facilities globally.</h4>

            {selectedPlantItem.equipment.map((eq, i) => (
              <div key={i} className="plant-item green">
                ✔ {eq}
              </div>
            ))}

            <button
              className="preview-plan-btn"
              onClick={() => userId ? setShowPaymentWindow(true) : setShowPaymentWindow(false) && Swal.fire(
                {
                  icon: "error",
                  title: "Login Required",
                  text: "Please login to process payment.",
                  showCancelButton: true,
                  confirmButtonText: "Login",
                  cancelButtonText: "Cancel",
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  didOpen: () => {
                    const c = document.querySelector('.swal2-container');
                    if (c) c.style.zIndex = '9999999999';
                  }
                }).then((result) => {
                  if (result.isConfirmed) {
                    // User clicked "Login" - redirect to login page
                    window.location.href = `https://nktechhub.com/login`;
                  } else if (result.isDenied || result.dismiss === Swal.DismissReason.cancel) {
                    // User clicked "Cancel" or closed the dialog
                    // Stay on current page
                    return;
                  }
                })

              }
            >
              Payment Plan
            </button>

            {showPaymentWindow && (
              <PaymentPlanWindow
                onClose={() => setShowPaymentWindow(false)}
                selectedSystemName={selectedPlantItem?.name}
                userId={userData.id ? userData.id : null}
                userData={userData}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default HomePage;